import { push } from 'connected-react-router';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { stringToNumber, roundToFourDecimals, getRouterSearchParam } from '../../helpers/functions';
import { PREMIUM_SETTINGS_COPY_FROM_PARAM } from '../../helpers/constants';
import {
  createStagedPremium,
  getSingleStagedPremium,
  requestStagedPremiumSettingsStages,
} from '../../reducers/stagedPremiumsWizard';
import StagedPremiumSettingsWizardHOC from './stagedPremiumSettingsWizardHOC';

const StagedPremiumSettingsCreateHOC = () => {
  const stagedPremiumSettingsWizard = useSelector(
    (state) => state.stagedPremiumsWizard
  );
  const premiumSettings = useSelector((state) => state.premiumSettings);
  const dispatch = useDispatch();
  const { search } = useLocation();

  useEffect(() => {
    // "Create New Based On Current": the source setting id arrives as ?copyFrom=<id>, read from the
    // React Router location (see getRouterSearchParam - same param/reader as the flat wizard).
    // getRouterSearchParam returns null for a present-but-empty "?copyFrom=", so that no longer
    // falls through to a GET .../Settings/ with no id.
    const copyFromId = getRouterSearchParam(search, PREMIUM_SETTINGS_COPY_FROM_PARAM);
    if (copyFromId) dispatch(getSingleStagedPremium(copyFromId));
    else dispatch(requestStagedPremiumSettingsStages());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = () => {
    const stagesSettingsBody = Object.values(
      stagedPremiumSettingsWizard.stagesSubSettings
    ).map((s) => {
      const premiumAmount = stringToNumber(s.premiumAmount);
      return {
        ...s,
        // Real, full-precision computed amount — this is what's stored. Round to 4dp
        // only to avoid raw floating-point noise (e.g. 66.66660000000001); the UI
        // rounds to 2dp for display separately, at render time.
        underwriterRate: roundToFourDecimals(
          stringToNumber(stagedPremiumSettingsWizard.underwriterRatePercentage) *
          0.01 *
          premiumAmount
        ),
        underwriterRatePercentage: stringToNumber(
          stagedPremiumSettingsWizard.underwriterRatePercentage
        ),
        stagedPremiumSubSettingCommissionDtos: Object.values(
          stagedPremiumSettingsWizard.agentCommissionsList
        ).map((c) => ({
          ...c,
          lawsysId: c.id,
          lawsysName: c.name,
          commission: roundToFourDecimals(
            stringToNumber(c.commissionPercentage) * 0.01 * premiumAmount
          ),
          commissionPercentage: stringToNumber(c.commissionPercentage),
        })),
      };
    });
    // evt.preventDefault();
    dispatch(
      createStagedPremium({
        validFrom: new Date(
          stagedPremiumSettingsWizard.validFrom
        )?.toDateString(),
        validUntil:stagedPremiumSettingsWizard.validUntil ? new Date(
          stagedPremiumSettingsWizard.validUntil
        )?.toDateString() : null,
        notes: stagedPremiumSettingsWizard.notes,
        comments: stagedPremiumSettingsWizard.comments,
        solicitorGroupId:
          premiumSettings.selectedSolicitorGroup === ''
            ? null
            : parseInt(premiumSettings.selectedSolicitorGroup),
        caseTypeId: parseInt(premiumSettings.selectedCaseType),
        subCaseTypeId:
          premiumSettings.selectedSubCaseType === '' ||
          premiumSettings.selectedSubCaseType === '0'
            ? null
            : parseInt(premiumSettings.selectedSubCaseType),
        workSourceId:
          premiumSettings.selectedWorksource === ''
            ? null
            : parseInt(premiumSettings.selectedWorksource),
        DeductibleOptionId: stagedPremiumSettingsWizard.selectedDeductible,
        CoverageOptionId: stagedPremiumSettingsWizard.selectedCoverageType,
        EndorsementOptionId: stagedPremiumSettingsWizard.selectedEndorsement,
        StagedPremiumSubSettings: stagesSettingsBody,
        averageExpectedPremium: stagedPremiumSettingsWizard.averageExpectedPremium,
      })
    );
  };

  return (
    <StagedPremiumSettingsWizardHOC
      isApplicationPremium={false}
      handleSubmit={handleSubmit}
      onCancel={() => dispatch(push('../premium-settings'))}
      isEdit={false}
    />
  );
};

export default StagedPremiumSettingsCreateHOC;
